import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "" }, "API Settings", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "API Key", -1)
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Workspace Id", -1)
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "API Key", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workspaceId) = $event)),
                disabled: "true",
                class: "w-100"
              }, null, 512), [
                [_vModelText, _ctx.workspaceId]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apiKey) = $event)),
                disabled: "true",
                class: "w-100"
              }, null, 512), [
                [_vModelText, _ctx.apiKey]
              ])
            ]),
            _createElementVNode("button", {
              variant: "warning",
              class: "btn btn-danger float-end mt-4",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generaeApiKey && _ctx.generaeApiKey(...args)))
            }, " re-generate API Key ")
          ])
        ])
      ])
    ])
  ]))
}